import { object, string } from 'yup';

export const IdentifyCustomerFormSchema = object({
  birthday: string().required(
    'mobileAdoption.identifyCustomer.form.birthday.required',
  ),
  accountNumber: string().required(
    'mobileAdoption.identifyCustomer.form.accountNumber.required',
  ),
});
